import { resources } from "./";

export type DashLanguages = keyof typeof resources;

export const DEFAULT_LANGUAGE: DashLanguages = "pt-BR";

export function isPlural(count: number, key: string) {
	return count > 1 || count === 0 ? `${key}_other` : `${key}_one`;
}
